import './Module.About.css';
import Banners from '../../../components/elements/Banners';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import { useEffect } from 'react';
import StaticBanner from '../../../components/elements/StaticBanner';
import BannerImg from '../../../../public/assets/images/BannersFiles/27.jpg';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../shared/Helper';
import { useState } from 'react';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';

const About = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [epUserID, setEpUserID] = useState(null);
  const { pathname } = useLocation();


  useEffect(() => {
    localStorage.setItem('isHome', true);
  }, []);


  useEffect(() => {

        const retrievedData = getFromLocalStorage('upid');
        retrievedData
          ?.then((res) => {
            setEpUserID(res);
          })
          .catch((err) => {
            console.log('data', err);
          });
    
    const role = localStorage.getItem('role');
    if (!role) {
      PageHitCountApi(pathname, 0);
    }


    if (role && epUserID != null && epUserID != 0) {
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);

  return (
    <div className="">
      <StaticBanner BannerImg={BannerImg} en_US={'About'} arabic={false} />
      <section
        className={`sm:h-90 flex xl:flex-row flex-col lg:py-10 px-3 lg:px-12 ${isActive ? 'text-left' : 'text-right'}`}
      >
        <img

          src={BannerImg}
          className=" m-4 md:max-w-screen-sm"
          alt=""
        />
        {/* <h2 className={`text-black text-4xl flex font-bold py-6  ${isActive ? 'justify-right ' : 'text-left '}`}>الرؤية والرسالة </h2> */}
        <div className="px-3 py-5 lg:p-5 ">
          <h4
            className={`text-customgreen flex sm:text-2xl  text-justify  ${isActive ? 'justify-right' : 'justify-left'}`}

          >
            {isActive
              ? `تأسست جمعية الشارقة الخيرية في عام 1989 بهدف تنفيذ الأعمال الإنسانية والخيرية.
وعلى مدى ثلاثة عقود، واصلت الجمعية تقديم المساعدات الإنسانية والصحية والتعليمية والثقافية للدول النامية، إلى جانب إتاحة الخدمات الاجتماعية الأساسية ودعم وكفالة الأيتام والأسر المتعففة والمحتاجة.  وينبع دعهما الثابت والمستمر للأشخاص المحتاجين والمجتمعات المعوزة من قيم الإيثار والعطاء المتأصلة في الثقافة الإماراتية.
`
              : `Sharjah Charity Association was established in 1989 with the aim of implementing humanitarian and charitable activities. Over the past three decades, the association has continued to provide humanitarian, health, educational, and cultural aid to developing countries, along with offering essential social services and supporting orphans and needy families. Their steadfast and continuous support for those in need stems from the values of altruism and generosity inherent in UAE culture.`}
          </h4>
        </div>
      </section>
    </div>
  );
};

export default About;
